import { useReveal } from "@/hooks/useReveal";

const TRUST = ["USDA Organic", "EU Organic", "HACCP", "INVIMA"];

export default function Hero() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section
      id="top"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20organic%20food%20co-packing%20production%20line%20with%20rows%20of%20unbranded%20brown%20kraft%20doypack%20pouches%20on%20a%20stainless%20steel%20filling%20machine%2C%20warm%20natural%20daylight%20streaming%20through%20industrial%20windows%2C%20earthy%20brown%20and%20cream%20tones%2C%20clean%20artisanal%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20editorial%20product%20photography&width=1600&height=900&seq=private-label-hero-01&orientation=landscape"
          alt="Unbranded kraft pouches on a stainless steel filling line in a certified organic co-packing plant in Colombia"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative w-full max-w-[1200px] mx-auto px-4 md:px-6 pt-28 md:pt-32 pb-14">
        <div ref={ref} className="reveal w-full lg:max-w-[60%]">
          <h1 className="text-white font-serif text-3xl md:text-5xl font-semibold leading-tight md:leading-[1.15]">
            Your brand, made in a certified organic plant, from small runs
          </h1>

          <p className="mt-6 text-cream/90 text-[17px] md:text-lg leading-relaxed max-w-2xl">
            Mesa Baja is a family-run manufacturer in Colombia&apos;s coffee
            region. We pack organic unrefined whole cane sugar and organic
            cocoa powder under your brand, with Ecocert USDA and EU Organic
            certification, HACCP and full export documentation. Our production
            volume is modest by design, which is exactly why we take on runs a
            larger plant will not.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#quote"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md bg-brand text-white text-base font-semibold hover:bg-brand-dark transition-colors"
            >
              Request a private label proposal
            </a>
            <a
              href="#plant"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md border border-white/60 text-white text-base font-semibold hover:bg-white/10 transition-colors"
            >
              See plant capacity and minimums
            </a>
          </div>

          <div className="mt-9 inline-flex flex-wrap items-center gap-x-6 gap-y-2 bg-white/10 backdrop-blur border border-white/15 rounded-lg px-5 py-3">
            {TRUST.map((item) => (
              <span
                key={item}
                className="flex items-center gap-2 text-cream/90 text-sm whitespace-nowrap"
              >
                <i className="ri-check-line text-brand"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}